import React, { Component } from "react";
import YETwoFirstPage from "./YETwoFirstPage";
import YETwoSecondPage from "./YETwoSecondPage";
import { isPdfPrintVersion } from "views/Pma/PmaEditor/CommonEditor/pdfPrintVersion";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";

class YETwo extends Component {
  componentDidMount() {
    // if (this.props.pdfPrintVersion || isPdfPrintVersion()) {
    //   require("./pdfye2print.scss");
    // } else

    if (this.props.printVersion) {
      require("./ye2print.scss");
    } else {
      require("./ye2styles.scss");
      require("./ye2-alt-editor.scss");
    }
  }
  render() {
    const {
      printVersion,
      fromEditor,
      pdfPrintVersion,
      version,
      agentData,
      hoData,
      currentArea,
      mlsAreas,
      coverPageDetails,
      aprilData,
      demoAccountHOName,
      demoAccountCoverPhoto,
      demoAccountAreaName,
      demoAccountCity,
      quarterlyAreaTable,
      testimonials,
      typeOfVersion,
      handlePropertyHighlightDialog,
      propertyPhotoDetailsDTO,
      pmaQuarterlyCombinedCityDTO,
      quadrantDetails,
      oldPhotoDetails,
      photoTableData,
      quarterlyCityTable,
      isDemo,
      MQCityDetails,
      bubbleBoxes,
      missionStatement,
      hasFlippedTeam,
      altAgentData,
      volunteerDetails,
      dashboardValuation,
      miniTableDetailsDTO,
      agentFocusInfoList,
      designDetailsInfoList,
      tpTrends2WatchList,
      showAllEditButtons,
      keyMarketAvgsList,
      showMedian,
      priceRangeDashBoardDetailsDTOArea,
      priceRangeDashBoardDetailsDTOCity,
    } = this.props;

    return (
      <div>
        <div
          className={
            (printVersion ? "ye2-print-page" : "ye2-pma-editor-page") +
            (fromEditor ? " from-editor-column-wrapper" : "") +
            (pdfPrintVersion ? " pdf-print-version" : "")
          }
        >
          <YETwoFirstPage
            agentData={agentData}
            hoData={hoData}
            currentArea={currentArea}
            mlsAreas={mlsAreas}
            printVersion={printVersion}
            fromEditor={fromEditor}
            pdfPrintVersion={pdfPrintVersion}
            version={version}
            coverPageDetails={coverPageDetails}
            aprilData={aprilData}
            demoAccountHOName={demoAccountHOName}
            demoAccountCoverPhoto={demoAccountCoverPhoto}
            demoAccountAreaName={demoAccountAreaName}
            testimonials={testimonials}
            typeOfVersion={typeOfVersion}
            handlePropertyHighlightDialog={handlePropertyHighlightDialog}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            quadrantDetails={quadrantDetails}
            agentFocusInfoList={agentFocusInfoList}
            designDetailsInfoList={designDetailsInfoList}
            tpTrends2WatchList={tpTrends2WatchList}
            quarterlyAreaTable={quarterlyAreaTable}
            quarterlyCityTable={quarterlyCityTable}
            isDemo={isDemo}
            bubbleBoxes={bubbleBoxes}
            hasFlippedTeam={hasFlippedTeam}
            altAgentData={altAgentData}
            volunteerDetails={volunteerDetails}
            MQCityDetails={MQCityDetails}
            dashboardValuation={dashboardValuation}
            showAllEditButtons={showAllEditButtons}
            keyMarketAvgsList={keyMarketAvgsList}
            showMedian={showMedian}
            priceRangeDashBoardDetailsDTOArea={
              priceRangeDashBoardDetailsDTOArea
            }
            priceRangeDashBoardDetailsDTOCity={
              priceRangeDashBoardDetailsDTOCity
            }
          />
          <YETwoSecondPage
            agentData={agentData}
            agentFocusInfoList={agentFocusInfoList}
            designDetailsInfoList={designDetailsInfoList}
            tpTrends2WatchList={tpTrends2WatchList}
            hoData={hoData}
            currentArea={currentArea}
            propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
            mlsAreas={mlsAreas}
            printVersion={printVersion}
            fromEditor={fromEditor}
            pdfPrintVersion={pdfPrintVersion}
            version={version}
            aprilData={aprilData}
            demoAccountCity={demoAccountCity}
            demoAccountHOName={demoAccountHOName}
            demoAccountAreaName={demoAccountAreaName}
            quarterlyAreaTable={quarterlyAreaTable}
            quarterlyCityTable={quarterlyCityTable}
            pmaQuarterlyCombinedCityDTO={pmaQuarterlyCombinedCityDTO}
            oldPhotoDetails={oldPhotoDetails}
            photoTableData={photoTableData}
            isDemo={isDemo}
            MQCityDetails={MQCityDetails}
            missionStatement={missionStatement}
            dashboardValuation={dashboardValuation}
            coverPageDetails={coverPageDetails}
            testimonials={testimonials}
            handlePropertyHighlightDialog={handlePropertyHighlightDialog}
            bubbleBoxes={bubbleBoxes}
            quadrantDetails={quadrantDetails}
            altAgentData={altAgentData}
            volunteerDetails={volunteerDetails}
            miniTableDetailsDTO={miniTableDetailsDTO}
            showAllEditButtons={showAllEditButtons}
            keyMarketAvgsList={keyMarketAvgsList}
            showMedian={showMedian}
            priceRangeDashBoardDetailsDTOArea={
              priceRangeDashBoardDetailsDTOArea
            }
            priceRangeDashBoardDetailsDTOCity={
              priceRangeDashBoardDetailsDTOCity
            }
          />
        </div>
      </div>
    );
  }
}

export default YETwo;
